// extracted by mini-css-extract-plugin
export default {"tourSkipped":"TourSkipped_tourSkipped__zlC8u","tourSkippedLink":"TourSkipped_tourSkippedLink__Q9v1v"};